import { Box, Skeleton } from '@mui/material';
import { neutral } from '../../themes/colors';

export const TableLoader = (p: {
  rows?: number;
  height?: number;
  color?: string;
}) => (
  <Box style={{ width: '100%' }}>
    {Array(p.rows || 3)
      .fill(0)
      .map((_, i) => (
        <Skeleton
          height={p.height || 82}
          sx={{
            backgroundColor: p.color || neutral['200'],
            borderRadius: '10px',
          }}
          key={i}
        />
      ))}
  </Box>
);
